module.exports = __webpack_public_path__ + "static/media/Industry-Bold.97264866.eot";